/* Otaku Dreams cart reservation timer.
   Counts down from N minutes, remembers the deadline per cart in sessionStorage,
   and re-attaches after the drawer re-renders. */
if (!customElements.get('od-cart-timer')) {
  customElements.define(
    'od-cart-timer',
    class OdCartTimer extends HTMLElement {
      connectedCallback() {
        this.minutes = Number(this.dataset.minutes) || 5;
        this.template = this.dataset.text || 'Cart reserved for [timer] more minutes!';
        this.key = 'od-cart-timer:' + (this.dataset.cartToken || 'cart');
        let deadline = 0;
        try {
          deadline = Number(sessionStorage.getItem(this.key)) || 0;
        } catch (e) {
          deadline = 0;
        }
        if (!deadline || deadline < Date.now()) {
          deadline = Date.now() + this.minutes * 60 * 1000;
          try {
            sessionStorage.setItem(this.key, String(deadline));
          } catch (e) {
            /* storage unavailable, timer still runs for this render */
          }
        }
        this.deadline = deadline;
        this.tick();
        this.interval = setInterval(() => this.tick(), 1000);
      }

      disconnectedCallback() {
        clearInterval(this.interval);
      }

      tick() {
        const left = Math.max(0, this.deadline - Date.now());
        const m = Math.floor(left / 60000);
        const s = Math.floor((left % 60000) / 1000);
        const stamp = m + ':' + String(s).padStart(2, '0');
        this.innerHTML = this.template.replace('[timer]', '<strong>' + stamp + '</strong>');
        if (left <= 0) {
          clearInterval(this.interval);
          this.hidden = true;
        }
      }
    }
  );
}
